import { ApolloError } from '@apollo/client';
import { Card, CardBody, Button } from '@heroui/react';
import { FiShoppingBag } from 'react-icons/fi';

interface BuyerListErrorStateProps {
  error: Error | ApolloError;
  refetch: () => void;
}

export const BuyerListErrorState = ({
  error,
  refetch,
}: BuyerListErrorStateProps) => {
  return (
    <Card className="max-w-md mx-auto bg-content1 border-danger-200">
      <CardBody className="text-center space-y-4 p-8">
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-danger-100 rounded-full flex items-center justify-center">
            <FiShoppingBag className="h-8 w-8 text-danger-600" />
          </div>
        </div>

        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-foreground">
            Error Loading Buyers
          </h3>
          <p className="text-default-600 text-sm leading-relaxed">
            {(error as any).message ||
              'Unable to load buyers. Please try again.'}
          </p>
        </div>

        <div className="flex flex-col gap-3 pt-4">
          <Button color="primary" onPress={() => refetch()} className="flex-1">
            Try Again
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};
